import api from './api';

export interface StandardMessage {
    id: number;
    name: string;
    type?: string | null;
    spanish_template: string;
    english_template: string;
    dutch_template: string;
    french_template: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export interface GenerateMessageRequest {
    template_id: number;
    language: string;
    variables: {
        [key: string]: string;
    };
}

export interface GenerateMessageResponse {
    success: boolean;
    message: string;
    language: string;
    data?: StandardMessage[];
    total?: number;
}

class StandardMessageService {
    async getAll(): Promise<StandardMessage[]> {
        try {
            const response = await api.get<GenerateMessageResponse>('/api/standard-messages');
            return response.data || [];
        } catch (error) {
            console.error('Error fetching standard messages:', error);
            throw error;
        }
    }

    async getByType(type: string): Promise<StandardMessage[]> {
        try {
            const response = await api.get<GenerateMessageResponse>(`/api/standard-messages?type=${type}`);
            return response.data || [];
        } catch (error) {
            console.error('Error fetching standard messages by type:', error);
            throw error;
        }
    }

    async getById(id: number): Promise<StandardMessage> {
        try {
            const response = await api.get<{ success: boolean; data: StandardMessage }>(`/api/standard-messages/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching standard message:', error);
            throw error;
        }
    }

    async generateMessage(request: GenerateMessageRequest): Promise<string> {
        try {
            const response = await api.post<GenerateMessageResponse>('/api/standard-messages/generate', request);
            return response.message;
        } catch (error) {
            console.error('Error generating message:', error);
            throw error;
        }
    }

    /**
     * Helper to extract variables from a reservation
     */
    buildVariablesFromReservation(reservation: any, house: any): { [key: string]: string } {
        return {
            guest_name: reservation.name_first_guess || 'Guest',
            house_name: house.name || house.address || 'Property',
            house_address: house.address || '',
            check_in_date: reservation.check_in_date ? new Date(reservation.check_in_date).toLocaleDateString() : '',
            check_out_date: reservation.check_out_date ? new Date(reservation.check_out_date).toLocaleDateString() : '',
            deposit_amount: reservation.deposit_number?.toString() || '150',
        };
    }
}

export default new StandardMessageService();
